// extracted by mini-css-extract-plugin
export default {"container":"side-nav_container__QlaTl","sidenav":"side-nav_sidenav__rhlT9","item":"side-nav_item__IAMHD","active":"side-nav_active__VfZoB","page":"side-nav_page__m5OqG"};